import * as React from 'react';
import { connect } from 'react-redux';

import { BannerPreviewPopup, BannerPreviewPopupProps } from '../../components/BannerPreviewPopup/BannerPreviewPopup';
import { GroupId } from '../../typings/groups';
import { State } from '../../typings/state';
import { TStateProps } from '../../typings/utils';

export interface OwnProps {
    anchor: React.ReactNode;
    onClick?: () => void;
    onCancel: () => void;
    id: string;
    showBannersCount: boolean;
    hasTransitionButton: boolean;
    isVisible: boolean;
    groupId: GroupId;
    cls?: string;
}

type StateProps = TStateProps<BannerPreviewPopupProps, OwnProps>;

const emptyPreviewData = {};

const mapStateToProps = (state: State, ownProps: OwnProps): StateProps => {
    const { groupId } = ownProps;
    const { bannersPreviewData } = state;
    const previewData = bannersPreviewData[groupId] || emptyPreviewData;
    const { banners, error } = previewData;

    return {
        banners,
        error
    };
};

const mergeProps = (stateProps: StateProps, dispatchProps: {}, ownProps: OwnProps): BannerPreviewPopupProps => {
    const { groupId, ...otherProps } = ownProps;

    return {
        ...stateProps,
        ...otherProps
    };
};

export const BannerPreviewPopupContainer = connect<StateProps, {}, OwnProps, BannerPreviewPopupProps>(
    mapStateToProps,
    {},
    mergeProps
)(BannerPreviewPopup);
